import { useCallback, useEffect, useState } from 'react';
import { arrayMove } from '@dnd-kit/sortable';
import { DefaultColumnResponse } from '../services/responses/default-columns.response';
import { DefaultColumnService } from '../services/default-columns.service';

/** Estado do arrasto: as linhas ficam locais para o movimento aparecer no drop sem esperar o servidor. */
export const useDefaultColumnsReorder = (
    records: DefaultColumnResponse[],
    refresh: boolean
) => {
    const [rows, setRows] = useState<DefaultColumnResponse[]>([]);

    const [allIds, setAllIds] = useState<string[]>([]);

    useEffect(() => {
        setRows(records ?? []);
    }, [records]);

    useEffect(() => {
        new DefaultColumnService()
            .getOrdered()
            .then((res) => setAllIds(res.data.data.map((column) => column.id)))
            .catch(() => setAllIds([]));
    }, [refresh]);

    /** Aplica e persiste; o erro sobe de propósito, para quem chama avisar e recarregar. */
    const reorder = useCallback(
        async (activeId: string, overId: string) => {
            const from = rows.findIndex((row) => row.id === activeId);
            const to = rows.findIndex((row) => row.id === overId);
            const globalFrom = allIds.indexOf(activeId);
            const globalTo = allIds.indexOf(overId);

            if (from < 0 || to < 0 || globalFrom < 0 || globalTo < 0)
                throw new Error('Lista de colunas dessincronizada.');

            const positions = rows.map((row) => row.sortOrder).sort((a, b) => a - b);
            const movedRows = arrayMove(rows, from, to).map((row, index) => ({
                ...row,
                sortOrder: positions[index],
            }));
            const movedIds = arrayMove(allIds, globalFrom, globalTo);

            const previousRows = rows;
            const previousIds = allIds;

            setRows(movedRows);
            setAllIds(movedIds);

            try {
                await new DefaultColumnService().reorder(movedIds);
            } catch (err) {
                setRows(previousRows);
                setAllIds(previousIds);
                throw err;
            }
        },
        [rows, allIds]
    );

    return { rows, reorder };
};
